import { createFileRoute } from '@tanstack/react-router'

import { RoleTemplatePage } from '#/modules/roles/role-template-page'

export const Route = createFileRoute('/_shell/role-templates/$templateId')({
  component: function RoleTemplateRoute() {
    const { templateId } = Route.useParams()
    return <RoleTemplatePage templateId={templateId} />
  },
})
